import carinaDefaultTheme from "./carinaDefaultFormula";
export { carinaDefaultTheme };
export default carinaDefaultTheme;
